import classnames from 'classnames';
import React, { ChangeEvent } from 'react';
import styles from './toggleButton.module.scss';
import QuestionMarkToolTip from '../QuestionMarkToolTip/QuestionMarkToolTip';

export interface ToggleButtonProps {
  checked: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  labelTextClassName?: string;
  ariaLabel?: string;
  label?: string;
  helpText?: string;
  disabled?: boolean;
}

const ToggleButton = ({
  checked,
  onChange,
  className,
  labelTextClassName,
  ariaLabel,
  label,
  helpText,
  disabled,
}: ToggleButtonProps) => {
  return (
    <div
      className={classnames('d-flex align-items-center')}
      onClick={(event) => event.stopPropagation()}
      data-cy="toggle-container"
    >
      <label
        data-testid={`checkbox-label`}
        className={classnames(styles.switch, className)}
        data-cy="toggle"
      >
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          aria-label={ariaLabel}
          disabled={disabled}
          data-testid={`checkbox_toggle`}
        />
        <span className={classnames(styles.slider, styles.round)}></span>
      </label>
      {label ? (
        <span
          className={classnames(
            'ml-2 text-nowrap',
            labelTextClassName || 'text-primary'
          )}
        >
          {label}
        </span>
      ) : null}
      {helpText && <QuestionMarkToolTip styles={styles} helpText={helpText} />}
    </div>
  );
};

export default ToggleButton;
